import Component from '../core/Component'
import anime from 'animejs'

export default class CourseProgressBar extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            total: null,
            current: null,
            bar: null
        }

        this.observer = null
        this.isVisible = false
        this.hasAnimated = false

        this.progress = 0
    }

    prepare() {
        if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(this.handleIntersection, {
                root: null,
                rootMargin: '50px',
                threshold: 1
            })

            this.observer.observe(this.element)
        }
    }

    handleIntersection = (entries, observer) => {
        const entry = entries[0]
        this.isVisible = entry.isIntersecting

        if (this.isVisible && !this.hasAnimated) {
            this.animate()
        }
    }

    animate() {
        this.hasAnimated = true
        anime({
            targets: this.ref.bar,
            width: [0, this.progress],
            duration: 1400,
            easing: 'easeOutExpo'
        })
    }

    update({current, total}) {
        this.hasAnimated = false

        this.progress = current/total * 100
        this.ref.current.textContent = current
        this.ref.total.textContent = total
        this.ref.bar.style.width = `${this.progress}%`
    }
}